'use client'

import React from 'react';
import { StyledWidgetDiv } from './platformAbout.styles';
import { IPlatform } from '../../types';
import Link from 'next/link';

interface IPlatformAboutProps {
    platform: Pick<IPlatform, "title" | "desc" | "link">;
}

export const PlatformAbout = ({ platform }: IPlatformAboutProps) => {
    return (
        <StyledWidgetDiv>
            <h2>About {platform.title}</h2>
            <div className='p' dangerouslySetInnerHTML={{ __html: platform.desc.replaceAll('\n', '<br>') }} />
            {platform.link &&
                <div
                    className='platform-link-wrapper'
                >
                    <p>Visit</p>
                    <Link
                        target='_blank'
                        rel='nofollow'
                        href={platform.link}
                    >
                        {platform.title}
                    </Link>
                </div>
            }
        </StyledWidgetDiv>
    );
};

